import { gql } from "graphql-tag"

export default gql`
  type Store {
    createdAt: String!
    id: ID!
    isInternationalShipping: Boolean!
    isPublished: Boolean!
    publishedAt: String
    storeLocationIds: [ID!]
    updatedAt: String!
    url: String!
    vendor: Vendor!
  }

  input StoreAddInput {
    isInternationalShipping: Boolean!
    isPublished: Boolean!
    publishedAt: String
    storeLocationIds: [ID!]
    url: String!
    vendorId: ID!
  }

  input StoreUpdateInput {
    isInternationalShipping: Boolean
    isPublished: Boolean
    publishedAt: String
    storeLocationIds: [ID!]
    url: String
    vendorId: ID
  }

  type StoresWave {
    cursor: String
    hasPrevData: Boolean
    hasNextData: Boolean!
    prevCursor: String
    stores: [Store]!
  }

  input GetQueryStores {
    createdAt: String
    isAscending: Boolean
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input GetQueryStoreLinks {
    createdAt: String
    isAscending: Boolean
    isPreOrder: Boolean
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input GetWaveQueryStores {
    createdAt: String
    cursor: String
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input SearchStoresInput {
    url: String
  }
`
